<div class="modal-header modal-block-primary">
  <button type="button" class="close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
  <h4 class="modal-title" *ngIf="selected?.Id">Edit Configuration</h4>
  <h4 class="modal-title" *ngIf="!selected?.Id">Add Configuration</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <label class="control-label">Parent ID</label>
        <app-select
          #parentSegmentList
          [items]="segmentOptions"
          [allowClear]="true"
          [selected]="parentSegmentSelected"
          [removed]="parentSegmentRemoved"
        >
        </app-select>
        <app-tooltip [form]="'system.entityGroup.configs'" [uid]="'ParentSegmentId'"></app-tooltip>
      </div>
    </div>

    <div class="col-md-2">
      <div class="form-group">
        <label class="control-label">Qualifier</label>
        <input
          type="text"
          #name
          class="form-control"
          name="ParentQualifierId"
          [(ngModel)]="selected.ParentQualifierId"
        />
        <app-tooltip
          [form]="'system.entityGroup.configs'"
          [uid]="'ParentQualifierId'"
        ></app-tooltip>
      </div>
    </div>

    <div class="col-md-2">
      <div class="form-group">
        <label class="control-label">Element</label>
        <input type="number" #name class="form-control" name="Element" value="1" readonly />
      </div>
    </div>

    <div class="col-md-5">
      <div class="friendlyName" *ngIf="parentSegmentDescription(); let f">
        <div title="{{ f.ToolTip }}">{{ f.FriendlyName }}</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <label class="control-label">*Segment ID</label>
        <app-select
          #targetSegmentList
          [items]="segmentOptions"
          [allowClear]="true"
          [selected]="targetSegmentSelected"
          [removed]="targetSegmentRemoved"
        >
        </app-select>
        <app-tooltip [form]="'system.entityGroup.configs'" [uid]="'SegmentId'"></app-tooltip>
      </div>
    </div>

    <div class="col-md-2">
      <div class="form-group">
        <label class="control-label">Qualifier</label>
        <input
          type="text"
          #name
          class="form-control"
          name="SegmentId"
          [(ngModel)]="selected.Qualifier"
        />
        <app-tooltip [form]="'system.entityGroup.configs'" [uid]="'Qualifier'"></app-tooltip>
      </div>
    </div>

    <div class="col-md-2">
      <div class="form-group">
        <label class="control-label"
          >{{
            selectedTransformationType && selectedTransformationType.text === 'DeleteSegment'
              ? ''
              : '*'
          }}Element</label
        >
        <input
          type="number"
          #name
          class="form-control"
          name="Element"
          [(ngModel)]="selected.ElementId"
        />
        <app-tooltip [form]="'system.entityGroup.configs'" [uid]="'ElementId'"></app-tooltip>
      </div>
    </div>

    <div class="col-md-5">
      <div class="friendlyName" *ngIf="targetSegmentDescription(); let f">
        <div title="{{ f.ToolTip }}">{{ f.FriendlyName }}</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label class="control-label">Transformation Type</label>
        <app-select
          #transformationTypeList
          [items]="transformationTypeOptions"
          [selected]="changeSelectedTransformationType"
        ></app-select>
        <app-tooltip
          [form]="'system.entityGroup.configs'"
          [uid]="'TransformationType'"
        ></app-tooltip>
      </div>
    </div>

    <div class="col-md-6">
      <div
        class="form-group"
        *ngIf="selectedTransformationType && selectedTransformationType.text !== 'DeleteSegment'"
      >
        <label class="control-label">Value</label>
        <input type="text" #name class="form-control" name="Value" [(ngModel)]="selected.Value" />
        <app-tooltip [form]="'system.entityGroup.configs'" [uid]="'Value'"></app-tooltip>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer" *ngIf="selected">
  <button type="button" class="btn btn-primary" (click)="saveClicked()" [disabled]="!canSave()">
    Save
  </button>
  <button type="button" class="btn btn-default" data-dismiss="modal" (click)="modalRef.hide()">
    Cancel
  </button>
</div>
